import { render, staticRenderFns } from "./NoChainScrollContainer.vue?vue&type=template&id=9148bcb4&scoped=true&"
import script from "./NoChainScrollContainer.vue?vue&type=script&lang=js&"
export * from "./NoChainScrollContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9148bcb4",
  null
  
)

export default component.exports